import { withStyles, MenuItem } from '@material-ui/core'

export const Item = withStyles(() => {
	return {
		root: {
			display: 'block',
			whiteSpace: 'inherit',
			paddingRight: 0,
		},
	}
})(MenuItem)
